module.exports = __webpack_public_path__ + "static/fonts/Poppins-SemiBold.6f1520d1.ttf";